import { isType } from '../../helpers'
import Rule from './Rule'

export default class Obj extends Rule {
  get ruleName () {
    return 'obj'
  }

  passes () {
    return isType(this.value, 'object')
  }
}
